const getRequestHeaders = (isMobile, additionalHeaders = {})=>({
        'x-model-version': '4',
        'x-is-mobile': isMobile ? 'Y' : 'N',
        ...additionalHeaders
    });
export { getRequestHeaders };
